import React, { useRef, useState } from 'react';
import { ArrowRight, Camera } from 'lucide-react';

/**
 * Global reusable "select a photo" widget — presets grid + device upload.
 * Props: title, photos (preset image URLs), onNext(photoSrc: string), onBack
 */
const PhotoPicker = ({ title = 'Select a photo', photos = [], onNext, onBack } = {}) => {
  const [selected, setSelected] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => setSelected(reader.result);
    reader.readAsDataURL(file);
  };

  return (
    <div className="magic-step magic-photo-picker px-4 py-4">
      <h3 className="magic-title">{title}</h3>

      <div className="magic-photo-grid">
        {photos.map((src) => (
          <button
            key={src}
            type="button"
            className={`magic-photo-tile${selected === src ? ' magic-photo-tile--selected' : ''}`}
            onClick={() => setSelected(src)}
          >
            <img src={src} alt="preset option" />
          </button>
        ))}

        <button
          type="button"
          className={`magic-photo-tile magic-photo-tile--upload${
            selected && !photos.includes(selected) ? ' magic-photo-tile--selected' : ''
          }`}
          onClick={() => fileInputRef.current?.click()}
        >
          {selected && !photos.includes(selected) ? (
            <img src={selected} alt="uploaded selection" />
          ) : (
            <>
              <Camera size={22} />
              <span>Upload</span>
            </>
          )}
        </button>
        <input ref={fileInputRef} type="file" accept="image/*" hidden onChange={handleFileChange} />
      </div>

      {onBack && (
        <button type="button" className="magic-link-btn" onClick={onBack}>
          Back
        </button>
      )}

      <button
        type="button"
        className="magic-fab"
        disabled={!selected}
        onClick={() => onNext && onNext(selected)}
        aria-label="Next"
      >
        <ArrowRight size={22} />
      </button>
    </div>
  );
};

export default PhotoPicker;
